<template>
  <div class="media-preview">
    <div class="media-header  hide-print">
      <div class="d-flex justify-content-start align-items-center">
        <div>
          <h1
            class="d-flex justify-content-start align-items-center"
          >
            {{ title }}
          </h1>
          <h3 class="text-muted">
            {{ subtitle }}
          </h3>
          <div
            class="badge text-uppercase"
            :class="{
              'badge-secondary': image_type === 'before',
              'badge-info': image_type === 'during',
              'badge-primary': image_type === 'after',
            }"
            v-if="image_type"
          >
            {{ image_type }}
          </div>
        </div>
        <div
          v-if="showControl"
          class="border-left ml-3 pl-3"
          style="border-width: 3px !important"
        >
          <button
            v-if="computedControls.delete"
            class="btn btn-danger btn-sm mx-2"
            @click="$emit('delete', defect)"
            title="Click to delete"
            data-toggle="tooltip"
            data-placement="bottom"
            @mouseover="helper.showTooltip"
            @mouseleave="helper.hideTooltip"
          >
            <font-awesome-icon :icon="['fas', 'trash-alt']" />
          </button>
          <button
            v-if="computedControls.add"
            class="btn btn-success btn-sm mx-2"
            @click="$emit('add', defect)"
            title="Click to add"
            data-toggle="tooltip"
            data-placement="bottom"
            @mouseover="helper.showTooltip"
            @mouseleave="helper.hideTooltip"
          >
            <font-awesome-icon :icon="['fas', 'plus']" />
          </button>
          <button
            v-if="computedControls.remove"
            class="btn btn-warning btn-sm mx-2"
            @click="$emit('remove', defect)"
            title="Click to remove"
            data-toggle="tooltip"
            data-placement="bottom"
            @mouseover="helper.showTooltip"
            @mouseleave="helper.hideTooltip"
          >
            <font-awesome-icon :icon="['fas', 'minus']" />
          </button>
        </div>
      </div>
      <div>
        <div class="btn-group mr-4" v-if="downloadImage">
          <button
            class="btn btn-light border shadow-sm btn-sm"
            @click="printImage()"
          >
            Download
          </button>
        </div>
        <div class="btn-group mr-4" v-if="hasNavigation">
          <button
            id="previous_image"
            class="btn btn-light border shadow-sm btn-sm"
            @click="navigatePrevious()"
            :disabled="!hasNavigation.previous"
            title="Previous image"
            data-toggle="tooltip"
            data-placement="bottom"
            @mouseover="helper.showTooltip"
            @mouseleave="helper.hideTooltip"
          >
            <font-awesome-icon :icon="['fas', 'angle-left']" />
          </button>
          <button
            id="next_image"
            class="btn btn-light border shadow-sm btn-sm"
            @click="navigateNext()"
            :disabled="!hasNavigation.next"
            title="Next image"
            data-toggle="tooltip"
            data-placement="bottom"
            @mouseover="helper.showTooltip"
            @mouseleave="helper.hideTooltip"
          >
            <font-awesome-icon :icon="['fas', 'angle-right']" />
          </button>
        </div>
        <button
          class="btn-close btn-light"
          @click="closePreview"
          data-placement="top"
          @mouseover="helper.showTooltip"
          @mouseleave="helper.hideTooltip"
          title="Close"
          data-toggle="tooltip"
          id="closeBtn"
        >
          &times;
        </button>
      </div>
    </div>
    <div class="media-container p-0  hide-print">
      <div class="placeholder" v-if="isLoading">
        <div class="spinner-border text-primary mr-3"></div>
        <span class="text-muted">Loading preview...</span>
      </div>
      <div id="osd" :class="{ invisible: isLoading }"></div>
      <div
        class="dashcam-map"
        :class="{
          invisible:
            !showMap || isNaN(this.defect.lat) || isNaN(this.defect.lng),
        }"
      >
        <div id="map" class="rounded overflow-hidden"></div>
        <Pin :key="mapPin._id" :map="map" :caseItem="mapPin" v-if="mapPin" />
      </div>
    </div>
    <div
      class="align-items-center justify-content-center h-100 w-100 show-print"
    >
      <div class="shadow overflow-hidden">
        <!-- <div v-if="image_data">
          <div class="border p-2 d-flex w-100 align-items-center">
            <div style="width: 40px" class="mr-2">
              <img src="@/assets/pckk-logo.png" class="w-100" />
            </div>
            <div style="font-size: 1.4rem; font-weight: bold">RONDA</div>
          </div>
          <div class="border p-2 d-flex justify-content-between">
            <div>
              <div style="font-size: 1.2rem !important; font-weight: bold">
                {{ helper.formatDate(image_data.case.timestamp) }}
              </div>
              <div>
                {{
                  helper.getRoadInfo({
                    name: image_data.case.road.name,
                    district: image_data.case.road.district,
                  })
                }}
              </div>
            </div>
            <div class="text-right">
              <div style="font-size: 1.2rem !important; font-weight: bold">
                Case Number: {{ image_data.case.caseNumber }}
              </div>
              <div>
                {{
                  helper.formatCoordinate([
                    image_data.case.lat,
                    image_data.case.lng,
                  ])
                }}
              </div>
            </div>
          </div>
        </div> -->
        <!-- <div class="border w-100 d-flex" v-if="image_type">
          <div class="border border-right p-2 text-capitalize">
            Image: {{ image_type }}
          </div>
          <div
            class="border border-right p-2 text-capitalize"
            v-if="image_data"
          >
            Status:
            <span v-if="image_data.case.isNotify"> Notify </span>
            <span v-if="image_data.case.isNoe"> NOE </span>
            <span v-else-if="image_data.case.nod_case"> NOD </span>
            <span v-else-if="image_data.case.status == 'solved'"> Closed </span>
            <span v-else-if="image_data.case.status == 'received'"> Open </span>
            <span v-else-if="image_data.case.status == 'pending'">
              Pending
            </span>
          </div>
          <div
            class="border border-right p-2 text-capitalize"
            v-if="image_data"
          >
            Report Type:
            {{ image_data.case.reportType }}
          </div>
        </div> -->
        <div
          class="d-flex justify-content-center border"
          style="width: 900px"
          v-if="url"
        >
          <img :src="url" class="w-100" />
        </div>

        <!-- <div>
          <div class="border p-2">
            Created By: {{ image_data.case.user.name }}
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import "mapbox-gl";
import Pin from "@/components/Pin";
import OSD from "openseadragon";
import Helper from "@/helper";

export default {
  name: "media-preview",
  props: [
    "url",
    "title",
    "subtitle",
    "component",
    "showMap",
    "defect",
    "showControl",
    "hasNavigation",
    "image_data",
    "downloadImage",
  ],
  components: {
    Pin,
  },
  data() {
    return {
      image_type: null,
      helper: Helper,
      map: null,
      mapPin: null,
      osd: null,
      isLoading: false,
      computedControls: {
        delete: false,
        add: false,
        remove: false,
      },
    };
  },
  watch: {
    image_data: {
      handler() {
        this.image_type = this.image_data?.image_type;
      },
      deep: true,
      immediate: true,
    },
    showControl: {
      handler() {
        if (this.showControl) {
          this.computedControls = this.showControl;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    printImage() {
      window.print();
    },
    navigatePrevious() {
      this.$emit("navigate", "previous");
    },
    navigateNext() {
      this.$emit("navigate", "next");
    },
    initMap() {
      return new Promise((resolve) => {
        mapboxgl.accessToken = process.env.VUE_APP_MAPBOX_KEY;

        if (!isNaN(this.defect.lat) && !isNaN(this.defect.lng)) {
          if (!this.map) {
            this.map = new mapboxgl.Map({
              container: "map",
              style: "mapbox://styles/mapbox/light-v11",
              center: [this.defect.lng, this.defect.lat],
              zoom: 10,
            });

            this.map.on("load", () => {
              resolve();
            });
          } else {
            this.map.setCenter([this.defect.lng, this.defect.lat]);
            this.map.setZoom(14);
          }

          this.mapPin = this.defect;
        }
      });
    },
    closePreview(e) {
      if (!this.isLoading) {
        $("body").off("keydown");

        if (this.map) {
          this.map.remove();

          this.map = null;
        }

        this.$nextTick(() => {
          this.$emit("close");
        });
      }
    },
  },
  mounted() {
    this.isLoading = true;

    this.osd = OSD({
      id: "osd",
      prefixUrl: "/osd/",
      crossOriginPolicy: "Anonymous",
      maxZoomPixelRatio: 10,
      navigationControlAnchor: OSD.ControlAnchor.ABSOLUTE,
    }).open({
      type: "image",
      url: `${this.url}`,
    });

    this.osd.addHandler("open", (res) => {
      if (this.showMap) {
        this.initMap();
      }

      $("body").on("keydown", (e) => {
        if (e.key == "ArrowLeft") {
          this.navigatePrevious();
        } else if (e.key == "ArrowRight") {
          this.navigateNext();
        } else if (e.key == "Escape") {
          this.closePreview();
        }
      });

      this.isLoading = false;
    });
  },
  beforeDestroy() {
    this.closePreview();
  },
};
</script>

<style lang="scss">
@import "@/assets/css/print.scss";
</style>